import axios from "axios";
import {axiosCatchHandler} from "../sharedGlobal";

const SET_LOADING = 'SET_LOADING';
const SET_CUSTOMERS = 'SET_CUSTOMERS';
const SET_FILTERS = 'SET_FILTERS';

const state = {
  loading: false,
  customers: [],
  filters: {
    search: '',
  },
};

const getters = {
  customers: ({customers}) => customers,
  loading: ({loading}) => loading,
  filters: ({filters}) => filters,
};

const actions = {
  fetchCustomers: async ({commit}, filters) => {
    commit(SET_LOADING, true);
    commit(SET_FILTERS, filters);

    try {
      const response = await axios.get('/merchant/customers', {
        params: {
          ...filters,
        },
      });
      commit(SET_CUSTOMERS, response.data.customers);
      commit(SET_LOADING, false);
    } catch (error) {
      axiosCatchHandler(error);
      commit(SET_LOADING, false);
    }

  }
};

const mutations = {
  [SET_LOADING]: (state, loading) => {
    state.loading = loading;
  },
  [SET_CUSTOMERS]: (state, customers) => {
    state.customers = customers;
  },
  [SET_FILTERS]: (state, filters) => {
    state.filters = filters;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}

